module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.3eb78905.webp";